import { displayDependentAvatar } from 'enrollment/features/Family/FamilyDetailsPage/components';
import { FamilyMemberProps } from '.';
import {
  FamilyMemberItemTextStyled,
  FamilyMemberNameContainerStyled,
  FamilyMemberReadonlyStyled,
} from './FamilyMemberStyled';

interface FamilyMemberReadonlyProps extends FamilyMemberProps {
  isTable?: boolean;
  relationship?: string;
  extraClass?: string;
  id?: string;
}

export const FamilyMemberReadonly = ({
  isYou,
  name,
  age,
  isTable,
  relationship,
  profile,
  extraClass,
  id,
}: FamilyMemberReadonlyProps) => {
  return (
    <FamilyMemberReadonlyStyled
      className={`${isTable ? 'w-50' : ''} ${extraClass}`}
      {...(id ? { id } : {})}
    >
      {displayDependentAvatar(profile, isTable ? 48 : 30)}

      {isTable ? (
        <FamilyMemberNameContainerStyled>
          <FamilyMemberItemTextStyled sx={{ fontWeight: 600 }}>
            {name}
          </FamilyMemberItemTextStyled>
          <FamilyMemberItemTextStyled className="text-capitalize">
            {relationship ? relationship : 'Dependent'}
          </FamilyMemberItemTextStyled>
        </FamilyMemberNameContainerStyled>
      ) : (
        <>
          <FamilyMemberItemTextStyled>
            {isYou ? 'You' : name}
          </FamilyMemberItemTextStyled>
          <FamilyMemberItemTextStyled>
            {age ? `(${age})` : ''}
          </FamilyMemberItemTextStyled>
        </>
      )}
    </FamilyMemberReadonlyStyled>
  );
};
